<template>
    <div class="pa-5">
        <v-col cols="12">
            <v-card class="pa-5">
                <v-card-title> Reporte de acciones de los usuarios en el sistema </v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field type="date" label="Fecha Inicial *" v-model="item.fecha_inicial"
                                    hide-details="auto"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field type="date" label="Fecha Final *" v-model="item.fecha_final"
                                    hide-details="auto"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="6">

                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" class="mr-2" small :loading="loading" @click="filtrar">
                        Buscar
                    </v-btn>
                    <v-btn color="info" class="mr-2" small :loading="loader" @click="onExportar">
                        Exportar
                    </v-btn>
                </v-card-actions>
                <br>
                <v-card-text>
                    <v-data-table dense :headers="cabecera" :items="items" :items-per-page="10" :search="search"
                    loading-text="Cargando... Por favor, espere"
                    no-data-text="No hay datos disponibles"
                    :loading="CargarAccionUsuarios"
                        class="elevation-1" :footer-props="{
                            'items-per-page-text': 'Resultados por página:',
                            'page-text': '{0}-{1} de {2}'
                        }">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
    </div>
</template>


<script>
import reportesesionesusuarios from '@/components/sesiones/reportesesionesusuarios.vue';
import global from '@/global';
import {
    mapState,
    mapActions
} from 'vuex';
// import axios from "axios";
import {axios2 as axios} from "@/interceptor/useApi";

export default {
    components: {
        reportesesionesusuarios
    },
    data() {
        return {
            loading: false,
            dialog: false,
            search: "",
            item: {
                fecha_inicial: '',
                fecha_final: ''
            },
            cabecera: [{
                text: "Nombre",
                value: "usuario",
                align: "left",
                class: "grey darken-1 dark white--text",
                width: 210
            },
            {
                text: "Email",
                value: "email",
                align: "left",
                class: "grey darken-1 dark white--text",
                width: 190
            },
            {
                text: "Acción",
                value: "accion",
                align: "left",
                class: "grey darken-1 dark white--text"
            },
            {
                text: "Vista",
                value: "vista",
                align: "left",
                class: "grey darken-1 dark white--text"
            },
            {
                text: "Detalle",
                value: "detalle",
                align: "left",
                class: "grey darken-1 dark white--text",
                width: 270
            },
            {
                text: "Fecha Acción",
                value: "created_at",
                align: "left",
                class: "grey darken-1 dark white--text",
                width: 180
            }
            ],
            items: [],
            loader: false
        }
    },
    computed: {
        ...mapState('reportes', ["SesionUsuarios"]),
        ...mapState('reportes', ["CargarAccionUsuarios"])
    },
    methods: {
        ...mapActions('reportes', ["cargaraccionesusuarios"]),

        exportarAexcel: async function (url, data) {
            this.loader = true;
            await axios({
                url: url,
                method: "POST",
                data: data,
                responseType: "blob"
            })
                .then(async (response) => {
                    this.loader = false;
                    var nombre_archivo = response.headers["nombre-archivo"];
                    if (response.data.type == "text/html") {
                        // no es excel, probablemente es json con un mensaje de error
                        const res = JSON.parse(await response.data.text());
                        if (!res.exito) {
                            alert(res.mensaje || "Sucedió un error, intentelo nuevamente");
                        }
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", nombre_archivo);
                        document.body.appendChild(link);
                        link.click();
                    }
                })
                .catch((error) => {
                    this.loader = false;
                    this.errorMessage = error.response.data;
                    console.error("error!", error);
                });
        },

        onExportar: function (index) {
            let url = global.ruta_api + "excel/reporteaccionesusuarios";
            this.exportarAexcel(url, this.item);
        },

        filtrar: async function () {
            this.items = await this.cargaraccionesusuarios(this.item);
        },

        cerrarModal: function () {
            this.dialog = false;
        }
    },
    async mounted() {
        this.items = await this.cargaraccionesusuarios(this.item);
    }
}
</script>
